var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull " }, [
    _c("div", { staticClass: "container mt-3  mt-md-5" }, [
      _c("div", { staticClass: "row justify-content-center " }, [
        !_vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4 pl-md-0" }, [_c("login")], 1)
          : _vm._e(),
        _vm._v(" "),
        !_vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4  pt-3 mt-3" }, [
              _vm.registration
                ? _c(
                    "div",
                    {
                      staticClass:
                        "form-row justify-content-center vaillantCont"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                        },
                        [
                          _vm.brand == "CHEBONUS"
                            ? _c("img", {
                                staticClass: "img-fluid widthFull",
                                attrs: {
                                  src: require("../../assets/images/regitem.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "HAPPYBONUS"
                            ? _c("img", {
                                staticClass: "img-fluid widthFull",
                                attrs: {
                                  src: require("../../assets/images/regitem.jpg")
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                        [
                          _vm.brand == "CHEBONUS"
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    " Regular text-left pb-0 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "Non sei ancora registrato a CheBonus?"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "HAPPYBONUS"
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    " Regular text-left pb-0 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "Non sei ancora registrato a HappyBonus?"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "CHEBONUS"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    " Regular text-left pb-4 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "\n              L'accesso all'area riservata è soggetto all'approvazione di Vaillant ed il servizio è rivolto ai professionisti del settore\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "HAPPYBONUS"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    " Regular text-left pb-4 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "\n              L'accesso all'area riservata è soggetto all'approvazione di Hermann Saunier Duval ed il servizio è rivolto ai professionisti del settore\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isAuthenticated
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary  mb-1",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { to: "/registration" }
                                },
                                [
                                  _vm._v(
                                    "\n              Registrati subito\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4 pt-3 mt-3" }, [
              _c(
                "div",
                { staticClass: "form-row justify-content-center vaillantCont" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                    },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: require("../../assets/images/area.jpg")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: require("../../assets/images/accountHSD.jpg")
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                    [
                      _c(
                        "h4",
                        { staticClass: " Regular text-left pb-0 pl-4 pr-4" },
                        [_vm._v("Area riservata aderente")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: " Regular text-left pl-4 pr-4" }, [
                        _vm._v(
                          "\n              Benvenuto " +
                            _vm._s(_vm.getProfile.name) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            " Regular text-left pb-3 pl-4 pr-4 underline pointer"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "green mb-1",
                              class: { redHSD: _vm.brand == "HAPPYBONUS" },
                              attrs: { to: "/account" }
                            },
                            [_c("b", [_vm._v("Modifica profilo ")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary white mb-1",
                          class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                          on: { click: _vm.logout }
                        },
                        [_vm._v("\n              Esci\n            ")]
                      )
                    ]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4 pt-3 mt-3" }, [
              _c(
                "div",
                { staticClass: "form-row justify-content-center vaillantCont" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                    },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: require("../../assets/images/callcenter.jpg")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: require("../../assets/images/callcenterHSD.jpg")
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                    [
                      _c(
                        "h4",
                        { staticClass: " Regular text-left pb-0 pl-4 pr-4" },
                        [_vm._v("Servizio clienti")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: " Regular text-left pb-0 pl-4 pr-4 " },
                        [
                          _vm._v(
                            "\n              Se hai bisogno di ulteriori informazioni\n\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "widthFull text-left pl-4 pr-4 pb-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "widthFull text-left mb-1",
                              attrs: { to: "/contact" }
                            },
                            [
                              _c("img", {
                                staticClass: "wa_icon mr-3",
                                attrs: {
                                  src: require("../../assets/images/wa.png")
                                }
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "green mr-3",
                                class: { redHSD: _vm.brand == "HAPPYBONUS" },
                                attrs: { icon: "headset", size: "2x" }
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "green mr-3",
                                class: { redHSD: _vm.brand == "HAPPYBONUS" },
                                attrs: { icon: "envelope", size: "2x" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary  mb-1",
                          class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                          attrs: { to: "/contact" }
                        },
                        [_vm._v("\n              Contattaci qui\n            ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 pr-md-0 pt-3 mt-3" }, [
          _vm.registration
            ? _c(
                "div",
                { staticClass: "form-row justify-content-center vaillantCont" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                    },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: require("../../assets/images/more.jpg")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: require("../../assets/images/moreHSD.jpg")
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "h4",
                            {
                              staticClass: " Regular text-left pb-0 pl-4 pr-4"
                            },
                            [_vm._v("Installa Vaillant e attiva CheBonus!")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "h4",
                            {
                              staticClass: " Regular text-left pb-0 pl-4 pr-4"
                            },
                            [
                              _vm._v(
                                "Installa Hermann Saunier Duval e attiva HappyBonus"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "p",
                            {
                              staticClass: " Regular text-left pb-3 pl-4 pr-4"
                            },
                            [
                              _vm._v(
                                "\n              Scopri i vantaggi unici di CheBonus, il servizio di Vaillant per fornire al tuo cliente lo sconto immediato in fattura.\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "p",
                            {
                              staticClass: " Regular text-left pb-3 pl-4 pr-4"
                            },
                            [
                              _vm._v(
                                "\n              Scopri i vantaggi unici di HappyBonus, il servizio di Hermann Saunier Duval per fornire al tuo cliente lo sconto immediato in fattura.\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary mb-1 mt-4",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: {
                                href:
                                  "https://www.vaillant.it/professionisti/prodotti/che-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n              Scopri di più\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary mb-1 mt-1",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: {
                                href:
                                  "https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n              Scopri di più\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3aaf92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3aaf92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/areaRiservata/index.vue
// module id = null
// module chunks = 